import isEmpty from 'lodash/isEmpty'
import type { PivotLayoutFilter, PivotLoadedDays } from '@ztechapps/common.contract'
import { describePivotCondition, describePivotValueComparison } from '../describe-pivot-condition'

/** One pivot filter in the card's Filters voice — a Condition as its operator and operands, a range with its loaded span when it runs past the loaded rows. */
export const describePivotFilter = (filter: PivotLayoutFilter, loadedDays: PivotLoadedDays[]): string => {
  if (filter.dateRange !== undefined) {
    const { from, to } = filter.dateRange
    const span = loadedDays.find((entry) => entry.field === filter.field)
    // A range running past the loaded rows still applies — state the loaded
    // span so the reply can say which header filter would load the rest.
    const pastSpan = span !== undefined && (from < span.from || to > span.to)
    return `${filter.field} ${from} to ${to}${pastSpan && span ? ` (loaded ${span.from} to ${span.to})` : ''}`
  }
  if (filter.conditionFilter !== undefined) {
    return `${filter.field} ${describePivotCondition(filter.conditionFilter)}`
  }
  if (filter.valueComparison !== undefined) {
    return `${filter.field} ${describePivotValueComparison(filter.valueComparison)}`
  }
  if (!isEmpty(filter.excludedValues)) {
    return `${filter.field} all except ${filter.excludedValues?.join(', ')}`
  }
  if (!isEmpty(filter.includedValues)) {
    return `${filter.field} ${filter.includedValues?.join(', ')}`
  }
  return filter.field
}
